import { NonLifeInsuranceProductCategoryKeyEnum } from "web_myplann/Infrastructure/Api/Api";

export const NON_LIFE_INSURANCE_TYPES = [
	"property",
	"household",
	"liability",
	"vehicle",
	"travel",
	"business",
	"accident",
] as const;

export type NonLifeInsuranceType = (typeof NON_LIFE_INSURANCE_TYPES)[number];

export const NON_LIFE_INSURANCE_PRODUCT_CATEGORIES: Record<
	NonLifeInsuranceType,
	NonLifeInsuranceProductCategoryKeyEnum
> = {
	property:
		NonLifeInsuranceProductCategoryKeyEnum.PropertyAndLiabilityInsurance,
	household:
		NonLifeInsuranceProductCategoryKeyEnum.PropertyAndLiabilityInsurance,
	liability:
		NonLifeInsuranceProductCategoryKeyEnum.PropertyAndLiabilityInsurance,
	vehicle: NonLifeInsuranceProductCategoryKeyEnum.VehicleInsurance,
	travel: NonLifeInsuranceProductCategoryKeyEnum.TravelInsurance,
	business:
		NonLifeInsuranceProductCategoryKeyEnum.BusinessPropertyAndLiabilityInsurance,
	accident: NonLifeInsuranceProductCategoryKeyEnum.AccidentInsurance,
};
